export const refineChannelLogoSrc = (account) => {
    const { logo, adverityLogo } = account;

    return adverityLogo || logo;
};
